module.exports = __webpack_public_path__ + "media/images/background/socialbg-5863546126ed37e10f660db05b17e544.jpg";